import axios from "axios";
import { STRINGS_ENV } from "../config/stringsEnv";

const API_URL = `${STRINGS_ENV.apiUrl}seasonal`;

const seasonalService = {
  getSeasonalGroups: async () => {
    const res = await axios.get(API_URL);
    return res.data?.seasonalCategories ?? [];
  },
};

export default seasonalService;
